<section class="customMenu text-center">
  <h3>
    Help page
  </h3>
  <br/>
  <img height="220" width="220" src="assets/images/under_construction.png">
</section>
